import axios from "axios";

const axiosConfig = {
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
    Accept: "application/json",
  },
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
  withCredentials: true,
};
const axiosInstance = axios.create(axiosConfig);

// Add a request interceptor
axiosInstance.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.error({ error });
    return Promise.reject(error);
  }
);

export default axiosInstance;
